import { cn } from "@/src/lib/utils";
import { Heading, Text } from "@/src/components/ui/Typography";

import type { AccordionItemData } from "./Accordion.types";

interface AccordionItemProps {
  item: AccordionItemData;
  open: boolean;
  onToggle: () => void;
}

export function AccordionItem({ item, open, onToggle }: AccordionItemProps) {
  return (
    <div className="border-b border-neutral-200 py-8 first:pt-0 last:border-b-0">
      <button
        type="button"
        onClick={onToggle}
        aria-expanded={open}
        className="flex w-full items-start gap-4 text-left md:flex-row-reverse md:gap-6"
      >
        <div className="relative mt-2 h-5 w-5 shrink-0 text-neutral-500">
          <span className="absolute top-1/2 left-0 h-px w-full -translate-y-1/2 bg-current" />
          <span
            className={cn(
              "absolute top-0 left-1/2 h-full w-px -translate-x-1/2 bg-current transition-transform duration-550 ease-out",
              open && "rotate-90",
            )}
          />
        </div>

        <Heading as="h3" size="headingMD" className="flex-1 text-neutral-700">
          {item.title}
        </Heading>
      </button>

      <div
        className={cn(
          "grid overflow-hidden transition-all duration-700 ease-[cubic-bezier(.22,1,.36,1)]",
          open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0",
        )}
      >
        <div className="min-h-0 overflow-hidden">
          <div className="border-t border-neutral-600 pt-4 mt-4 ml-9 md:border-t-0 md:pt-4 md:pl-0 md:ml-0">
            <Text size="bodySM" className="max-w-135 text-neutral-600">
              {item.content}
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
}
